/**
 * URSH Fine Jewelry - Luxury Motion & Scroll Reveal Engine
 * Zero dependencies, pure IntersectionObserver, silky smooth 60fps performance
 */
(function() {
  'use strict';

  // If user prefers reduced motion, exit early
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  function initLuxuryMotion() {
    // If in Shopify Theme Editor (customizer), do not run to avoid editor interference
    if (window.Shopify && window.Shopify.designMode) {
      return;
    }

    // Only run animations on homepage
    if (!document.body || !document.body.classList.contains('template-index')) {
      return;
    }

    // Check if IntersectionObserver is supported
    if (!('IntersectionObserver' in window)) {
      return;
    }

    // Mark motion as active in HTML class
    document.documentElement.classList.add('ursh-motion-active');

    var elementsToReveal = document.querySelectorAll(
      '.template-index .luxury-categories__header, ' +
      '.template-index .luxury-categories__item, ' +
      '.template-index .luxury-product-grid:not(.related-products) .luxury-product-grid__header, ' +
      '.template-index .luxury-product-grid:not(.related-products) .luxury-product-grid__cards, ' +
      '.template-index .luxury-duo-banners__banner, ' +
      '.template-index .luxury-editorial-row, ' +
      '.template-index .ursh-reveal'
    );

    if (!elementsToReveal.length) return;

    var revealObserver = new IntersectionObserver(
      function(entries, observer) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            // Once revealed, unobserve to free memory and keep element revealed
            observer.unobserve(entry.target);
          }
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -40px 0px',
        threshold: 0.08
      }
    );

    elementsToReveal.forEach(function(el) {
      // If element is already in viewport on load, reveal immediately
      var rect = el.getBoundingClientRect();
      var windowHeight = window.innerHeight || document.documentElement.clientHeight;
      if (rect.top < windowHeight * 0.95 && rect.bottom > 0) {
        el.classList.add('is-revealed');
      } else {
        revealObserver.observe(el);
      }
    });

    // Also observe any dynamic elements loaded later (e.g. infinite scroll / dynamic products)
    try {
      var docObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) {
              if (node.matches && node.matches('.luxury-product-grid__cards, .luxury-categories__item')) {
                revealObserver.observe(node);
              } else if (node.querySelectorAll) {
                node.querySelectorAll('.luxury-product-grid__cards, .luxury-categories__item').forEach(function(child) {
                  revealObserver.observe(child);
                });
              }
            }
          });
        });
      });

      docObserver.observe(document.body, { childList: true, subtree: true });
    } catch(e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLuxuryMotion);
  } else {
    initLuxuryMotion();
  }
})();
